export default __webpack_public_path__ + "static/media/jetpackcompose.b6165c1f.svg";